import type { JSX } from 'react';
import { CheckCircleIcon } from '@c2fo/liquidity/icons';

const ELIGIBILITY_ITEMS = [
  {
    title: 'Applicant Requirements',
    description: 'Apply using your own information. You must be an owner or authorized signer.',
  },
  {
    title: 'Personal Credit Score',
    description:
      "A personal FICO score of 600 or above is required. The minimum doesn't guarantee approval; other factors are considered.",
  },
  {
    title: 'Credit Freeze Or Lock',
    description:
      'A frozen or locked Experian credit file cannot be reviewed. Remove or temporarily lift the freeze or lock with Experian before applying.',
  },
  {
    title: 'Bank Activity and NSFs',
    description:
      'Fundbox reviews recent activity in the business checking account you connect, including overdrafts and returned (NSF) payments. Accounts with at least 3 months of transaction history are needed.',
  },
];

const FundboxEligibilityChecklist = (): JSX.Element => (
  <div className="flex flex-col items-center space-y-8">
    <div className="space-y-2 text-center">
      <p className="text-3xl">Your Eligibility Checklist</p>
      <p className="text-lg">Fundbox and its bank partners review the following for eligibility</p>
    </div>
    <div className="w-full rounded-2xl bg-white shadow-md">
      {ELIGIBILITY_ITEMS.map((item, index) => (
        <div key={item.title}>
          <div className="flex flex-col gap-4 p-8 lg:flex-row lg:items-center lg:gap-8">
            <div className="flex items-center gap-4 lg:w-[350px] lg:shrink-0 lg:gap-6">
              <CheckCircleIcon className="size-6 shrink-0 fill-text-secondary" aria-hidden />
              <p className="text-lg font-medium">{item.title}</p>
            </div>
            <p className="text-base">{item.description}</p>
          </div>
          {index < ELIGIBILITY_ITEMS.length - 1 ? <div className="border-t border-deepGray-500/[12%]" /> : null}
        </div>
      ))}
    </div>
  </div>
);

export default FundboxEligibilityChecklist;
